import React from "react";
import { Routes, Route, useLocation } from "react-router";

// Constant
import {
    ROUTES, COMMON_FEATURES
} from '../../../../constants'

// Components
import { asyncComponent } from '../../../../components'

// Modules
import MapPanel from '../../../../modules/MapPanel'
import UserHierarchyMap from '../../../../modules/UserHiearchyMap'
import VehicleInformationPanel from '../../../../modules/VehicleInformationPanel'
import OverallManagementPanel from "../../../../modules/OverallManagementPanel";
import MaintenanceManagementModule from '../../../../modules/MaintenanceManagementModule'
import UserInfoMainPanel from '../../../../modules/UserManagement/modules/UserInfoMainPanel'
import HighwaySurveillanceManagement from '../../../../modules/HighwaySurveillanceManagement'
import FuelAnalysisDashboard from '../../../../modules/FuelAnalysisDashboard'
import VehicleOverallReport from '../../../../modules/VehicleOverallReport'
import DriverAdd from "../../../../modules/DriverManagement/module/DriverAdd";
import DeviceCUForm from "../../../../modules/DeviceManagement/modules/DeviceCUForm";
// import VehicleCUForm from "../../../../modules/VehicleManagement/modules/VehicleCUForm";
import VehicleCUForm2 from "../../../../modules/VehicleManagement/modules/VehicleCUForm2";
import VehicleGroupCUForm from "../../../../modules/VehicleManagement/modules/VehicleGroupCUForm";
import RuleTemplateCUForm from "../../../../modules/OverallManagementPanel/components/RuleEnginePanel/components/RuleTemplateCUForm";
import RuleCUForm from "../../../../modules/OverallManagementPanel/components/RuleEnginePanel/components/RuleCUForm";
// import RouteCUForm from "../../../../modules/RouteManagement/modules/RouteCUForm";
import UserEditForm from "../../../../modules/UserManagement/modules/UserInfoMainPanel/components/UserEditForm";
import UserAddForm from "../../../../modules/UserManagement/modules/UserInfoMainPanel/components/UserAddForm";
import { DriverReport, DeviceReport , IncidentCUForm} from '../../../../modules/OverallReport/modules'
import { VehicleIssueAdd, VehicleIssueEdit } from '../../../../modules/VAM/components/VAMVehicleIssues/modules/CUVehicleIssue'
import { ServiceEntryAdd, ServiceEntryEdit } from '../../../../modules/VAM/components/VAMEntryManagement/modules/CUServiceEntry'
// // Thiry Party
import GreenerWheelsModule from '../../../../modules/GreenerWheelsModule'

import {
    VAM
} from '../../../../modules'

const {
    MAP_ROUTE,
    MODULE_ROUTE,
    OVERALL_MANAGEMENT_ROUTE,
    MAINTENANCE_MANAGEMENT_MODULE_ROUTE,
    VAM_MODULE_ROUTE
} = ROUTES

const AsyncNotFoundPage = asyncComponent(() => import("../../../../pages/NotFoundPage"));

const MainRoutes = () => {

    const location = useLocation();
    const { state = {} } = location;

    const VIData = state && state.data

    return (
        <Routes>

            {
                Object.keys(MAP_ROUTE).map((key) =>
                    <Route 
                        key={key} 
                        exact
                        path={MAP_ROUTE[key]}
                        element={<MapPanel />}
                    />
                )
            }

            <Route exact
                path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.UPDATE_USER]}
                element={<UserEditForm data={VIData} />}
            />
            <Route exact
                path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.CREATE_USER]}
                element={<UserAddForm data={VIData} />}
            />
            <Route exact
                path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.CREATE_DRIVER]}
                element={<DriverAdd />}
            />
            <Route exact
                path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.UPDATE_DRIVER]}
                element={<DriverAdd data={VIData} />}
            />

            <Route exact
                path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.CREATE_VEHICLE]}
                // element={<VehicleCUForm />}
                element={<VehicleCUForm2 />}
            />
            
            <Route exact
                path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.UPDATE_VEHICLE]}
                element={<VehicleCUForm2 data={VIData}/>}
            />

            <Route exact
                path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.CREATE_VEHICLE_GROUP]}
                element={<VehicleGroupCUForm />}
            />
            
            <Route exact
                path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.UPDATE_VEHICLE_GROUP]}
                element={<VehicleGroupCUForm data={VIData}/>}
            />
            
            <Route exact
                path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.CREATE_RULE]}
                element={<RuleCUForm />}
            />

            <Route exact
                path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.UPDATE_RULE]}
                element={<RuleCUForm data={VIData} />}
            />

            <Route exact
                path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.CREATE_RULE_TEMPLATE]}
                element={<RuleTemplateCUForm />}
            />
            <Route exact
                path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.UPDATE_RULE_TEMPLATE]}
                element={<RuleTemplateCUForm data={VIData} />}
            />

            {/* <Route exact
                path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.CREATE_ROUTE]}
                element={<RouteCUForm />}
            /> */}

            <Route exact
                path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.CREATE_DEVICE]}
                element={<DeviceCUForm data={VIData} />}
            />
            
            <Route exact
                path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.UPDATE_DEVICE]}
                element={<DeviceCUForm data={VIData}/>}
            />

            <Route exact
                path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.USER_HIERARCHY_MAP]}
                element={<UserHierarchyMap />}
            />

            <Route exact
                path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.VEHICLE_INFORMATION_PANEL]}
                element={<VehicleInformationPanel/>}
            />

            {/** Management */}

            <Route exact 
                path = {MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.USER_MANAGEMENT]} 
                element={<UserInfoMainPanel />}
            />

            <Route exact 
                path = {MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.HIGHWAY_SURVEILLANCE_MANAGEMENT]} 
                element={<HighwaySurveillanceManagement />}
            />

            {
                Object.keys(OVERALL_MANAGEMENT_ROUTE).map((key) =>
                    <Route 
                        key={key} exact
                        path={OVERALL_MANAGEMENT_ROUTE[key]}
                        element={<OverallManagementPanel />}
                    />
                )
            }

             {/** Maintenance Management Module*/}

             {
                Object.keys(MAINTENANCE_MANAGEMENT_MODULE_ROUTE).map((key) =>
                    <Route 
                        key={key} exact
                        path={MAINTENANCE_MANAGEMENT_MODULE_ROUTE[key]}
                        element={<MaintenanceManagementModule />}
                    />
                )
            }

             {/** VAM */}

             {
                Object.keys(VAM_MODULE_ROUTE).map((key) =>
                    <Route 
                        key={key} exact
                        path={VAM_MODULE_ROUTE[key]}
                        element={<VAM />}
                    />
                )
            }

            {/** Report */}

            <Route exact
                path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.FUEL_ANALYSIS_DASHBOARD]}
                element={<FuelAnalysisDashboard />}
            />

            <Route exact
                path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.VEHICLE_OVERALL_REPORT]}
                element={<VehicleOverallReport />}
            />

            <Route exact
                path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.DRIVER_REPORT]}
                element={<DriverReport />}
            />

            <Route exact
                path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.CREATE_DRIVER_INCIDENT_REPORT]}
                element={<IncidentCUForm />}
            />

            <Route exact
                path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.DEVICE_REPORT]}
                element={<DeviceReport />}
            />

            <Route exact
                path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.CREATE_VEHICLE_ISSUE]}
                element={<VehicleIssueAdd />}
            />

            <Route exact
                path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.EDIT_VEHICLE_ISSUE]}
                element={<VehicleIssueEdit data={VIData}/>}
            />

            <Route exact
                path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.CREATE_SERVICE_ENTRY]}
                element={<ServiceEntryAdd/>}
            />

            <Route exact
                path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.EDIT_SERVICE_ENTRY]}
                element={<ServiceEntryEdit data={VIData}/>}
            />

            {/** Greener Wheels */}

            <Route exact
                path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.GREENER_WHEELS]}
                element={<GreenerWheelsModule />}
            />

            <Route element={<AsyncNotFoundPage />} />

        </Routes>
    )
}
export default MainRoutes